import { useState } from 'react';
import { Tooltip } from '../ui';
import { copyToClipboard } from '../../lib/clipboard';
import type { Contact } from '../../whats-new/preface';

/** A name that copies its e-mail address on click (the tooltip shows the address). */
export function ContactLink({ name, email }: Contact) {
  const [state, setState] = useState<'idle' | 'copied' | 'failed'>('idle');
  const copy = async () => {
    setState((await copyToClipboard(email)) ? 'copied' : 'failed');
    setTimeout(() => setState('idle'), 1800);
  };
  const hint =
    state === 'copied' ? `Copié : ${email}` : state === 'failed' ? `À copier à la main : ${email}` : `Cliquer pour copier l'e-mail · ${email}`;
  return (
    <Tooltip content={hint}>
      <button
        type="button"
        onClick={copy}
        className="font-semibold text-primary-700 underline decoration-primary-300 decoration-dotted underline-offset-2 hover:text-primary-900"
      >
        {name}
      </button>
    </Tooltip>
  );
}
